export var Construction;
(function (Construction) {
    Construction["BuildAProperty"] = "BUILD_A_PROPERTY";
    Construction["KnockdownRebuild"] = "KNOCKDOWN_REBUILD";
    Construction["StructuralRenovations"] = "STRUCTURAL_RENOVATIONS";
})(Construction || (Construction = {}));
//# sourceMappingURL=Construction.js.map